import { tablePaginationClasses, toolbarClasses } from '@mui/material'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const C1PagedListStyles: moduleStyleType = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
    },
    pagination: {
        minHeight: '48px',
        backgroundColor: 'transparent',

        [`&.${tablePaginationClasses.root}`]: {
            [`& .${toolbarClasses.root}`]: {
                minHeight: 0,
            },
        },
    },
}
